export class UserMap {
    ID: any;
    Title: string;
    Zoom: number;
    Coordinates: number[];
    Primary: boolean;
    Shared: boolean;
    Deletable: boolean;
    DefaultLayerID: any;
    Latitude: number;
    Longitude: number;
}